import { useEffect, useState } from "react";
import HubUsageSelectionFilterDialog from "./HubUsageSelectionFilterDialog";

export default function HubUsageFileFilterDialog(props) {
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        if (props.files) {
            setSelectedKeys(
                props.files
                    .filter(
                        (file) =>
                            !props.excludedFileKeys.includes(file.key),
                    )
                    .map((file) => file.key),
            );
        }
    }, [props.files, props.excludedFileKeys, props.open]);

    function handleClose() {
        props.onClose(
            props.files
                .filter((file) => !selectedKeys.includes(file.key))
                .map((file) => file.key),
        );
    }

    function handleToggle(key) {
        setSelectedKeys(
            selectedKeys.includes(key)
                ? selectedKeys.filter((selectedKey) => selectedKey !== key)
                : [...selectedKeys, key],
        );
    }

    return (
        <HubUsageSelectionFilterDialog
            open={props.open}
            onClose={handleClose}
            title="File filter"
            items={props.files.map((file) => ({
                key: file.key,
                label: file.displayName,
            }))}
            selectedKeys={selectedKeys}
            onToggle={handleToggle}
            onToggleAll={() =>
                setSelectedKeys(
                    selectedKeys.length === props.files.length
                        ? []
                        : props.files.map((file) => file.key),
                )
            }
        />
    );
}
